
import { mdiGavel, mdiInformation } from '@mdi/js'
import utils from '@/components/tools/utils'
import auctionHistory from '@/components/tools/auctionHistory'

export default {
  name: 'AuctionHistory',

  icons: {
    mdiGavel,
    mdiInformation
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    auction () {
      return this.product.auction
    },
    history () {
      return this.product.auction?.history || {}
    },
    numberOfAuctions () {
      return auctionHistory.getNumberOfAuctions(this.history?.numberOfAuctions, this)
    },
    sellerLastOnline () {
      const startingAt = this.product?.auction?.startingAt
      const avUpdatedAt = this.product?.auction?.availabilityConfirmation?.updatedAt
      const lastOnlineAt = this.history?.sellerLastOnline
      const now = new Date()

      let result
      try {
        const candidates = [lastOnlineAt, avUpdatedAt, now]
        if (this.product?.auction?.anrs === 0) {
          candidates.push(startingAt)
        }
        // newest date that is set, parseable and not in the future
        result = candidates
          .filter(d => d && !isNaN(new Date(d)) && new Date(d) <= now)
          .sort((a, b) => new Date(b) - new Date(a))[0]
      } catch (e) {
        console.error(e)
        result = lastOnlineAt
      }

      return auctionHistory.getSellerLastOnline(result, this)
    },

    availabilityConfirmed () {
      try {
        if (this.product?.auction.anrs === 1) {
          const found = this.product?.archivedAuctions?.find(a =>
            a.autoRound === false && a.anrSeason === this.product?.auction.anrSeason
          )
          if (found) {
            return auctionHistory.getAvailabilityConfirmed(found?.startingAt, this)
          }
        } else if (this.product?.auction.anrs === 0) {
          return auctionHistory.getAvailabilityConfirmed(this.product?.auction?.startingAt, this)
        }

        return auctionHistory.getAvailabilityConfirmed(this.product?.auction?.availabilityConfirmation?.updatedAt, this)
      } catch {
        return auctionHistory.getAvailabilityConfirmed(this.product?.auction?.availabilityConfirmation?.updatedAt, this)
      }
    },

    lastRejectedBid () {
      return auctionHistory.getLastRejectedBid(this.history?.lastRejectedHighestBidDate, this.history?.lastRejectedHighestBid)
    },
    items () {
      return []
    },

    discounts () {
      if (!this.history?.priceReductions || this.history.priceReductions.length === 0) {
        return []
      }

      return this.history?.priceReductions?.map((reduction) => {
        return {
          amount: this.formatCurrency(reduction.reduction),
          date: this.formatDate(reduction.createdAt),
          newPrice: this.formatCurrency(reduction.targetPrice)
        }
      })
    }

  },
  methods: {
    formatCurrency (value) {
      return utils.formatCurrency(value)
    },
    formatDate (date) {
      return utils.formatDateWithoutTimeShort(date)
    }

  }
}
